(() => {
  const reopenKey = 'livana:reopen-cart';

  window.LivanaCartRecovery = {
    reload() {
      try {
        window.sessionStorage.setItem(reopenKey, '1');
      } catch {
        // Reload still works when browser storage is unavailable.
      }
      window.location.reload();
    },
    reopen(drawer) {
      let shouldOpen = false;
      try {
        shouldOpen = window.sessionStorage.getItem(reopenKey) === '1';
        window.sessionStorage.removeItem(reopenKey);
      } catch {
        return;
      }
      if (shouldOpen) drawer.open(document.getElementById('cart-icon-bubble'));
    },
  };

  document.addEventListener('click', (event) => {
    if (!event.target.closest?.('[data-livana-cart-recover]')) return;
    event.preventDefault();
    window.LivanaCartRecovery.reload();
  });
})();
